<template>
  <div class="stepBox">
    <qiangzhi :type="3"/>
    <div class="step">
      <fengxian  />
      <InspectSearch ismode/>
    </div>
    
    <fuwu :type="2" />
    <mElectronicFooter disabledNext/>
  </div>
</template>

<script>
import mixins from "./mixins";
import InspectSearch from "@/views/Inspect/InspectSearch.vue";
export default {
  mixins: [mixins],
  components: { InspectSearch },
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {},
};
</script>

<style scoped lang="scss">
@use "~@/views/hetongqianshu/step/index.scss" as *;
</style>
